import React, { useEffect } from 'react'
import classNames from 'classnames'

import Button from './Button'
import { t } from '@/i18n'

interface Props {
  backTo?: string
  className?: string
  title?: string
  visible?: boolean
  onClose?: () => void
  children: React.ReactNode
}

const Modal: React.FC<Props> = ({
  className,
  title,
  backTo,
  visible,
  onClose,
  children,
}) => {
  useEffect(() => {
    document.body.style.position = visible ? 'fixed' : 'inherit'
    return () => {
      document.body.style.position = 'inherit'
    }
  }, [visible])
  return (
    <div
      className={classNames('modal-wrap', {
        open: Boolean(visible),
        [className || '']: !!className,
      })}
    >
      <div className="overlay" />
      <div className="modal-content">
        {!!onClose && (
          <div className="close-modal">
            <Button onClick={onClose}>
              <span className="icon-close"></span>
            </Button>
          </div>
        )}
        {!!title && (
          <div className="modal-title">
            <h3>{title}</h3>
          </div>
        )}
        {!!backTo && (
          <div className="prev-box">
            <Button
              onClick={() => {
                /*TODO*/
              }}
            >
              <span className="icon-arrow"></span>
              {t('backTo', { page: backTo })}
            </Button>
          </div>
        )}
        <div className="content-box">{children}</div>
      </div>
    </div>
  )
}

export default Modal
